import { render, staticRenderFns } from "./AdminFieldsBlock.vue?vue&type=template&id=358e2597&scoped=true"
import script from "./AdminFieldsBlock.vue?vue&type=script&lang=js"
export * from "./AdminFieldsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e2597",
  null
  
)

export default component.exports